import { createSlice } from "@reduxjs/toolkit";
import { ButtonData } from "../types";

interface InitialProps {
  primaryButtonData: ButtonData | null;
  secondaryButtonData: ButtonData | null;
  tertiaryButtonData?: ButtonData | null;
  isNavigating: boolean;
}

const initialState: InitialProps = {
  primaryButtonData: null,
  secondaryButtonData: null,
  tertiaryButtonData: null,
  isNavigating: false,
};

const buttonsSlice = createSlice({
  name: "buttons",
  initialState,
  reducers: {
    onUpdatePrimaryButton: (state, action) => {
      state.primaryButtonData = {
        ...state.primaryButtonData,
        ...action.payload,
      };
    },
    onUpdateSecondaryButton: (state, action) => {
      state.secondaryButtonData = {
        ...state.secondaryButtonData,
        ...action.payload,
      };
    },
    onUpdateTertiaryButton: (state, action) => {
      state.tertiaryButtonData = {
        ...state.tertiaryButtonData,
        ...action.payload,
      };
    },
    onUpdateIsNavigating: (state, action) => {
      state.isNavigating = action.payload;
    },
  },
});

export const {
  onUpdatePrimaryButton,
  onUpdateSecondaryButton,
  onUpdateTertiaryButton,
  onUpdateIsNavigating,
} = buttonsSlice.actions;

export default buttonsSlice.reducer;
